<template name="dateTimePicker">
  <div>
    <input
      type="text"
      :class="hasclass ? hasclass : 'time-input'"
      :placeholder="placeholder"
      @click="showPicker"
      :value="pickerValueStr"
      readonly>
    <mt-datetime-picker
      ref="picker"
      :type="type ? type  : 'datetime'"
      v-model="pickerValue"
      :startDate="minDate"
      :endDate="maxDate"
      :cancelText="$t('Cancel')"
      :confirmText="$t('confirm')"
      @confirm="handleConfirm"
    ></mt-datetime-picker>
  </div>
</template>

<script type="text/javascript">
import Moment from 'moment';
import Vue from 'vue';
import 'mint-ui/lib/style.css';
// import 'mint-ui/lib/datetime-picker/style.css';
import { DatetimePicker } from 'mint-ui';

Vue.component(DatetimePicker.name, DatetimePicker);

/**
 * Usage example:
 * bind placeholder to display placeholder for datetime picker
 * v-model with date str('' or 'YYYY-MM-DD HH:mm');
 * bind change event to handle selected date str
 * <dateTimePicker
 *  placeholder="Please select start date"
 *  v-model="startDate"
 *  @change="handleChange"
 *  ></dateTimePicker>
 */

export default {
  name: 'dateTimePicker',
  props: {
    placeholder: String,
    isStartDate: Boolean,
    isEndDate: Boolean,
    type: String,
    hasclass: String
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      minDate: null,
      maxDate: null,
      // pickerValue: new Date(),
    };
  },
  created() {
    const { isStartDate, isEndDate } = this.$props;
    // get current moment
    const currentMoment = Moment(new Date());
    // set minDate to first date of current year (date range picker)
    // or -100 years from now (single date picker)
    const minDate = (isStartDate || isEndDate)
      ? currentMoment.clone().dayOfYear(1).hours(0).minutes(0)
        .toDate()
      : currentMoment.clone().subtract(100, 'years').hours(0).minutes(0)
        .toDate();
    this.minDate = minDate;

    // set maxDate to  1 (date range picker) or 100(single picker) years from now;
    const maxDate = currentMoment.clone().add((isStartDate || isEndDate) ? 1 : 100, 'years').toDate();
    this.maxDate = maxDate;
  },
  computed: {
    pickerValue: {
      get() {
        const { isEndDate } = this.$props;
        const { value } = this.$attrs;
        let currentMoment = Moment(new Date());
        if (isEndDate) {
          currentMoment = currentMoment.hours(18).minutes(0);
        } else { // start date picker or single date picker
          currentMoment = currentMoment.hours(0).minutes(0);
        }
        return value ? Moment(value).toDate() : currentMoment.toDate();
      },
      set() {
      },
    },
    pickerValueStr() {
      return this.$attrs.value;
    },
  },
  methods: {
    showPicker(event) {
      this.$refs.picker.open();
      event.currentTarget.blur();
    },
    formatDateToStr(date) {
      if (this.type == 'date') {
        return date.format('YYYY-MM-DD');
      } else {
        return date.format('YYYY-MM-DD HH:mm');
      } 
    },
    handleConfirm(dateObj) {
      const selectedMoment = Moment(dateObj);
      const formatedDateStr = this.formatDateToStr(selectedMoment);
      this.$emit('change', formatedDateStr);
    },
  },
};
</script>

<style lang="scss">
  .mint-datetime-action {
    font-weight: bold;
    color: #e42029;
  }
</style>
<style lang="scss" scoped>
  .time-input {
    width: 100% !important;
    text-align: right !important;
    margin-bottom: 0;
    background: url('../assets/images/arrow-copy.png') no-repeat right;
    background-size: 8px;
    padding-right: 20px !important;
    color: #4a4a4a;
    border: none !important;
    font-size: 13px;
    &::-webkit-input-placeholder {
      color: #929292;
    }
  }
  .no-style {
    background: none;
    padding-right: 0 !important;
    border: 1px solid #ccc;
    margin-bottom: 0;
    font-size: 14px;
    margin-left: 0;
    padding: 0 4px;
    width: 120px;
    color: #434343;
    vertical-align: top;
  }
  .no-style1 {
    background: none;
    padding-right: 0 !important;
    margin-bottom: 0;
    font-size: 14px;
    margin-left: 0;
    padding: 0 4px;
    width: 100%;
    line-height: 24px;
    color: #434343;
    vertical-align: top;
  }
</style>
